export default "__VITE_ASSET__69670db2__"